import "react-toastify/dist/ReactToastify.css";

import EditiableNotificationCard from "@pages/Notification/common/components/EditNotificationCard";
import ViewNotificationCard from "@pages/Notification/common/components/ViewNotificationCard";
import PauseModal from "@components/Modals/WarningModal";
import StartModal from "@components/Modals/WarningModal";
import { TitleWithDivider } from "@common/TitleWithDivider";
import { error_message } from "@constants/Errors";
import pageHeaders from "@constants/PageHeaders";
import { useNotificationPage } from "@pages/Notification/ViewNotificationPage/hooks/useNotificationPage";

const ViewNotificationPage: React.FC = () => {
  const form = useNotificationPage();

  return (
    <>
      <TitleWithDivider
        titleText={pageHeaders.NOTIFICATION.view}
        useDivider={true}
      />
      {form.notification ? (
        <div className="md:gap-6 xl:grid-cols-4 2xl:gap-7.5">
          {!form.viewOnly && form.isAdminLoggedIn ? (
            <EditiableNotificationCard
              notificationData={form.notification}
              setNotificationData={form.setNotification}
              isEditing={form.isEditing}
              viewOnly={form.viewOnly}
            />
          ) : (
            <ViewNotificationCard notificationData={form.notification} />
          )}

          {!form.viewOnly && form.isAdminLoggedIn && (
            <div className="flex justify-between items-center gap-2.5 mt-8">
              <div
                className="inline-flex items-center justify-center gap-2.5 delete-button-frame"
                onClick={
                  form.notification?.status === false
                    ? form.handleStartClick
                    : form.handleStopClick
                }
              >
                {form.notification?.status === false ? "再配信" : "配信停止"}
              </div>
              <div className="flex justify-end">
                <div
                  className="button-cancel"
                  onClick={form.handleCancelButtonClick}
                >
                  キャンセル
                </div>
                <div
                  className="button-confirm"
                  onClick={form.handleUpdateButtonClick}
                >
                  {form.isEditing === false ? "更新する" : "確認"}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="not-found-text">
          {error_message.notification.not_found(form.id)}
        </p>
      )}

      <PauseModal
        isOpen={form.pauseModalOpen}
        onRequestClose={form.handleStopCloseModal}
        onConfirm={form.handleStopConfirm}
        title={form.pauseModalTitle}
        body={form.pauseModalBody}
        confirmText={form.pauseModalConfirm}
        cancelText={""}
      />

      <StartModal
        isOpen={form.startModalOpen}
        onRequestClose={form.handleCloseStartModal}
        onConfirm={form.handleStartConfirm}
        title={form.startModalTitle}
        body={form.startModalBody}
        confirmText={form.startModalConfirm}
        cancelText={""}
      />
    </>
  );
};

export default ViewNotificationPage;
